module.exports = __webpack_public_path__ + "media/images/icons/geolocation-25a589b0dfdeee761f8ac3dd357446aa.svg";